import { useCallback, useMemo } from 'react';
import { __AUTHORIZATIONS__ } from 'shell/constants/environment';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import { Feature } from 'shell/models/feature';
import { RouteConfig, RoutesConfig } from 'shell/router/routes-config';
/**
 * The hook to check if to filter the user routes
 * @param {RoutesConfig} routes the routes to check
 * @returns {RoutesConfig} is authorized for this routes
 */

export const useRouteAuthorization = (routes?: RoutesConfig): RoutesConfig => {
  const { userProfile } = useUserProfile();
  const authorizationItems = useMemo(
    () => userProfile.datiLogin?.profile?.authorizationItems?.slice() || [],
    [userProfile.datiLogin?.profile?.authorizationItems]
  );

  const filterAuthRoutes = useCallback(
    (inputRoutes?: RoutesConfig): RoutesConfig =>
      inputRoutes
        ?.map((route: RouteConfig) => {
          if (route.authorizations) {
            const found = route.authorizations?.find((authorization) =>
              authorizationItems.find((auth) => authorization === auth)
            );
            if (!found) {
              return;
            }
          }

          if (route.abilitations) {
            const foundAbilitation = Object.keys(route.abilitations || {})?.find(
              (keyAbilitation) => {
                const featureUser = userProfile.datiLogin?.profile?.feature || {};
                const key = keyAbilitation as keyof Feature;
                const featureValueUser = featureUser[key];
                const featureMenuAbilitations = route.abilitations || {};
                const featureValue = featureMenuAbilitations[key];

                if (featureValue?.includes(featureValueUser as string)) {
                  return true;
                }
                return false;
              }
            );

            if (!foundAbilitation) {
              return;
            }
          }

          if (route.children) {
            return { ...route, children: filterAuthRoutes(route.children) };
          }
          return route;
        })
        .filter((definedRoute) => definedRoute) as RoutesConfig,
    [authorizationItems]
  );
  const authRoutes = useMemo(() => filterAuthRoutes(routes?.slice()), [routes, filterAuthRoutes]);
  return __AUTHORIZATIONS__ ? authRoutes : routes || [];
};
